'use client' // Error components must be Client Components

import { NavBar } from '@components/app/NavBar'
import { BackNavigationCaret } from '@components/app/NavBar/BackNavigationCaret.client'
import Button, { buttonClassNames } from '@components/primitives/Button'
import { IconSuffix } from '@components/primitives/Icon/IconSuffix'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight'
import { createDataDogRumLogger } from '@lib/logger/createDataDogRumLogger'
import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { TrackingSources } from '@lib/tracking/TrackingSources'
import { useEffect } from 'react'

export default function Error({
  error,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    const dataDogRumLogger = createDataDogRumLogger()
    dataDogRumLogger.error(error, {
      source: TrackingSources.PATIENT,
      type: 'client-error',
    })

    const trackingProperties = {
      source: TrackingSources.PATIENT,
      val: error.message,
    }
    //TODO: enrich with DataDog RUM Logs
    trackEvent(
      TrackingEvents.PATIENT_CLIENT_ERROR_BOUNDARY_HIT,
      trackingProperties,
    )
  }, [error])

  return (
    <div className='mx-auto flex h-screen max-w-screen-xl justify-center pt-20'>
      <NavBar includeNavigationLinks={false} showLogo={false}>
        <BackNavigationCaret />
      </NavBar>
      <div className='flex h-full flex-col items-center justify-center gap-4'>
        <div className='flex flex-col items-center justify-center gap-6 rounded-2xl p-12'>
          <Text className='pb-1' element='h1' styleName='h1'>
            Oops!
          </Text>
          <Text className='text-center' element='h2' styleName='h4'>
            {`We're experiencing a higher volume of patient interest than normal.`}
          </Text>
          <Text className='-mt-4' element='p' styleName='p-strong'>
            Please reload this page in order to restore your experience.
          </Text>
          <Button
            className={classMerge(
              buttonClassNames.legacy.fill.primary,
              'group pointer-events-auto w-full rounded-full transition-all duration-200 md:w-1/4',
            )}
            onClick={() => {
              window.location.reload()
            }}
          >
            <IconSuffix icon={faArrowRight}>
              <span className='mr-2 transition-all'>Try Again</span>
            </IconSuffix>
          </Button>
        </div>
      </div>
    </div>
  )
}
